Unit MainDataModule;

Interface

Uses
  System.SysUtils,
  System.Classes,
  Generics.Collections,
  JS,
  Web,
  WEBLib.Modules,
  XData.Web.Client,
  XData.Web.Connection,
  Web.Core.Config,
  Web.Core.Consts,
  Data.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  App.Enumerations,
  App.ReturnTypes,
  App.Web.Consts,
  WEBLib.CDS,
  Sphinx.WebLogin,
  WEBLib.Forms,
  WEBLib.DB,
  App.Shared, WEBLib.ClientConnector;

{
  // TODO -oAFP: why are these here?

  Debug Authority: http://alpha:2024/AlphaLogin
  Demo Site: https://alpha.smxi-azure-001.smxi.com/AlphaLogin
}

{

  Emails sent on BookingDataset.AfterApplyUpdates for Confirmations (Cheque, BACS) and Payments.AfterApplyUpdates for successful payments.

  Emails also sent in BookingDataset.AfterApplyUpdates for Waitlist

  Holiday and RoomAllocations are Updated when the Holiday is Confirmed (Cheque, BACS), Deposit Paid or Fully Paid.

}

Type

  TUserProfile = class
    UserName: string;
    Email: string;
    Scope: string;
  end;

  TMainData = Class(TDataModule)
    DataConnection: TXDataWebConnection;
    WebClient: TXDataWebClient;
    DummyLookUp: TClientDataSet;
    DummyLookUpSource: TDataSource;
    SphinxLogin: TSphinxWebLogin;
    AcademyLookUp: TXDataWebDataSet;
    AcademyLookUpId: TIntegerField;
    AcademyLookUpName: TStringField;
    SchoolLookUp: TXDataWebDataSet;
    IntegerField1: TIntegerField;
    SchoolLookUpLocationName: TStringField;
    CostingDetailDataSet: TXDataWebDataSet;
    WebClientDataSet1: TClientDataSet;
    WebClientConnector1: TClientConnector;
    CostingDetailDataSetId: TIntegerField;
    CostingDetailDataSetDateAdded: TDateTimeField;
    CostingDetailDataSetAddedBy: TIntegerField;
    CostingDetailDataSetLastUpdatedBy: TIntegerField;
    CostingDetailDataSetLastUpdated: TDateTimeField;
    CostingDetailDataSetCostingId: TIntegerField;
    CostingDetailDataSetPupilMin: TIntegerField;
    CostingDetailDataSetPupilMax: TIntegerField;
    CostingDetailDataSetCostValue: TFloatField;
    InvoiceDetailDataSet: TXDataWebDataSet;
    InvoiceDetailDataSetId: TIntegerField;
    InvoiceDetailDataSetDateAdded: TDateTimeField;
    InvoiceDetailDataSetAddedBy: TIntegerField;
    InvoiceDetailDataSetLastUpdatedBy: TIntegerField;
    InvoiceDetailDataSetLastUpdated: TDateTimeField;
    InvoiceDetailDataSetDescription: TStringField;
    InvoiceDetailDataSetInvoiceId: TIntegerField;
    InvoiceDetailDataSetQuantity: TIntegerField;
    InvoiceDetailDataSetRate: TFloatField;
    InvoiceDetailDataSetTotalValue: TFloatField;
    InvoiceLookup: TXDataWebDataSet;
    RemittanceLookup: TXDataWebDataSet;
    InvoiceLookupId: TIntegerField;
    InvoiceLookupDateAdded: TDateTimeField;
    InvoiceLookupAddedBy: TIntegerField;
    InvoiceLookupLastUpdatedBy: TIntegerField;
    InvoiceLookupLastUpdated: TDateTimeField;
    InvoiceLookupDueDate: TDateField;
    InvoiceLookupGrossAmount: TFloatField;
    InvoiceLookupInvoiceDate: TDateField;
    InvoiceLookupInvoiceRef: TStringField;
    InvoiceLookupInvoiceType: TStringField;
    InvoiceLookupNetAmount: TFloatField;
    InvoiceLookupParentId: TIntegerField;
    InvoiceLookupTaxRate: TFloatField;
    InvoiceLookupTax: TFloatField;
    InvoiceLookupTotalAmount: TFloatField;
    RemittanceLookupId: TIntegerField;
    RemittanceLookupDateAdded: TDateTimeField;
    RemittanceLookupAddedBy: TIntegerField;
    RemittanceLookupLastUpdatedBy: TIntegerField;
    RemittanceLookupLastUpdated: TDateTimeField;
    RemittanceLookupInvoiceId: TIntegerField;
    RemittanceLookupSchoolId: TIntegerField;
    RemittanceLookupPaymentMethod: TStringField;
    RemittanceLookupRemittanceDate: TDateField;
    RemittanceLookupPaymentState: TStringField;
    RemittanceLookupAmount: TFloatField;
    RemittanceLookupPaymentRef: TStringField;
    RemittanceLookupPaymentKind: TStringField;
    InvoiceLookupPaidInFull: TBooleanField;
    AcademyLookUpDateAdded: TDateTimeField;
    AcademyLookUpAddedBy: TIntegerField;
    AcademyLookUpLastUpdatedBy: TIntegerField;
    AcademyLookUpLastUpdated: TDateTimeField;
    AcademyLookUpEmail: TStringField;
    AcademyLookUpTelephone: TStringField;
    SchoolLookUpDateAdded: TDateTimeField;
    SchoolLookUpAddedBy: TIntegerField;
    SchoolLookUpLastUpdatedBy: TIntegerField;
    SchoolLookUpLastUpdated: TDateTimeField;
    SchoolLookUpAdd1: TStringField;
    SchoolLookUpAdd2: TStringField;
    SchoolLookUpAdd3: TStringField;
    SchoolLookUpTown: TStringField;
    SchoolLookUpRegion: TStringField;
    SchoolLookUpPostCode: TStringField;
    SchoolLookUpCountryCode: TStringField;
    SchoolLookUpExternalId: TStringField;
    SchoolLookUpTelephone: TStringField;
    SchoolLookUpEmail: TStringField;
    SchoolLookUpLocalAuthority: TStringField;
    SchoolLookUpAcademyId: TIntegerField;
    SchoolLookUpStatus: TStringField;
    SchoolLookUpSchoolKind: TStringField;
    SchoolLookUpPupilCount: TIntegerField;
    InvoiceLookupHandbookSent: TBooleanField;
    CostingLookUp: TXDataWebDataSet;
    CostingLookUpId: TIntegerField;
    CostingLookUpDateAdded: TDateTimeField;
    CostingLookUpAddedBy: TIntegerField;
    CostingLookUpLastUpdatedBy: TIntegerField;
    CostingLookUpLastUpdated: TDateTimeField;
    CostingLookUpTitle: TStringField;
    CostingLookUpValidFrom: TDateTimeField;
    CostingLookUpValidTo: TDateTimeField;
    SchoolLookUpCostingId: TIntegerField;
    Procedure DataConnectionRequest(Args: TXDataWebConnectionRequest);
    Procedure DataConnectionResponse(Args: TXDataWebConnectionResponse);
    procedure SphinxLoginUserLoggedIn(Args: TUserLoggedInArgs);
    Procedure WebClientError(Error: TXDataClientError);
    [async]
    Procedure WebDataModuleCreate(Sender: TObject); async;
    procedure AutoReloadAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure CostingDetailDataSetAfterPost(DataSet: TDataSet);
    procedure WebDataModuleDestroy(Sender: TObject);
  Private
    { Private declarations }
    FLoadPromiseResolve: TJSPromiseResolver;
    FLoadPromiseResolveCalled: Boolean;
    FLoadPromiseDataset: TXDataWebDataSet;
    FLoadPromiseOriginalAfterOpen: TDataSetNotifyEvent;

    procedure InternalAfterOpenForLoad(DataSet: TDataSet);
    
    function CreateLoadPromise: TJSPromise;

    FInitDone: Boolean;
    FSessionId: Integer;
    FProcessingState: TProcessingState;
    FStoredProcessingState: TProcessingState;
    FMainPage: TMainAppPage;
    FPreviousMainPage: TMainAppPage;

    // CallBacks
    FOnReadyToProgress: TOnReadyToProgress;

    FDebugInfo: String;
    FErrorMessage: String;

    FAllDataSaved: TAllDataRequired;
    FAllDataOpened: TAllDataRequired;

    FErrorMessageProc: TErrorMessageProc;
    FLastOutcome: TBasicResponse;
    FReloadOnInit: Boolean;
    FUserProfile: TUserProfile;

    Function GetLocalValue(Const Key: String): String;
    Procedure SetLocalValue(Const Key, Value: String);

    Function GetSessionValue(Const Key: String): String;
    Procedure SetSessionValue(Const Key, Value: String);

    Procedure OnApplicationError(Sender: TObject; AError: TApplicationError; Var Handled: Boolean);
    [async]
    Procedure HandleAnException(AException: EGeneralXDataException; Var Handled: Boolean); async;

    Function LocalValueKeyStartsWith(Const Value: String): String;

    [async]
    Procedure ProcessQuery; async;

    [async]
    Procedure CheckAllLoaded; async;
    Procedure CloseAllData;

    [async]
    Procedure ConfigInit; async;
    [async]
    Procedure InitModule; async;
    [async]
    Procedure LoadConfig; async;

    Function GetDebugInfo: String;

    Procedure SetProcessingState(Const Value: TProcessingState);

    Procedure SetMainPage(Const Value: TMainAppPage);
    Procedure UnlinkAllCallBacks;
    Function GetPageSwitched: Boolean;

    [async]
    Procedure SaveAllData; async;
    Procedure SaveAllDataCheck;

    [async]
    procedure FetchUserProfile; async;

    Property MainPage: TMainAppPage Read FMainPage Write SetMainPage;

  Public
    { Public declarations }

    Procedure RaiseException(Const AMessage: String);

    Procedure SaveData;

    procedure ResetProcessingState;

    [Async]
    procedure OpenAcademyLookUp; async;

    [Async]
    procedure OpenCostingLookUp; async;

    [async]
    procedure OpenSchoolLookUp; async;

    [async]
    procedure OpenCostingDetail(aCostingId: Integer); async;

    [async]
    procedure OpenInvoiceDetail(aInvoiceId: Integer); async;

    [async]
    procedure LoadInvoices(SchoolId: Integer); async;

    [async]
    procedure LoadRemittanceLookup(InvoiceId: Integer); async;

    [async]
    procedure LoadRemittanceById(Id: Integer); async;

    [async]
    procedure LoadRemittances; async;

    Procedure SwitchMainPage(Const APage: TMainAppPage);

    procedure RemoveLocalValue(const Key: string);

    procedure DebugLog(aValue: string);

    procedure LogoutUser(Const AForceRelogin: Boolean = False);

    // properties
    Property DebugInfo: String Read GetDebugInfo;

    Property LastOutcome: TBasicResponse read FLastOutcome;

    Property ProcessingState: TProcessingState Read FProcessingState Write SetProcessingState;

    Property OnReadyToProgess: TOnReadyToProgress Write FOnReadyToProgress;
    Property ErrorMessageProc: TErrorMessageProc Read FErrorMessageProc Write FErrorMessageProc;

    Property ErrorMessage: String Read FErrorMessage Write FErrorMessage;
    /// <summary>
    /// Returns True if not Logged In or Customer Id is not present in the JWT
    /// </summary>

    Property LocalValue[Const Key: String]: String Read GetLocalValue Write SetLocalValue;
    Property SessionValue[Const Key: String]: String Read GetSessionValue Write SetSessionValue;
    Property PageSwitched: Boolean Read GetPageSwitched;

    property UserProfile: TUserProfile read FUserProfile;

  protected procedure LoadDFMValues; override; End;

Var
  MainData: TMainData;

Implementation

{%CLASSGROUP 'Vcl.Controls.TControl'}
{$R *.dfm}

Uses
  Rtti,
  System.DateUtils,
  System.StrUtils,
  Math,
  XData.Web.Request,
  XData.Web.Response,
  WEBLib.Storage,
  WEBLib.WebTools,
  XData.Dataset.Utils,
  MainSitePage,
  smx.webcore.Types,
  smx.Auth.Shared,
  smx.Web.Document.Utils,
  smx.XDataSvc.Utils,
  App.Web.Utils,
  smx.Web.Utils,
  smx.CRM.Utils,
  SchoolListPage,
  WEBLib.Dialogs;

Const
  Process_State = 'ProcessState';
  Last_Section = 'LastSection';

procedure TMainData.InternalAfterOpenForLoad(DataSet: TDataSet);
begin
  // Restore original handler
  if Assigned(FLoadPromiseDataset) then
  begin
    FLoadPromiseDataset.AfterOpen := FLoadPromiseOriginalAfterOpen;
    
    // Resolve the promise
    if not FLoadPromiseResolveCalled and Assigned(FLoadPromiseResolve) then
    begin
      FLoadPromiseResolveCalled := True;
      FLoadPromiseResolve(JSValue(DataSet));
    end;
    
    // Call original handler if it exists
    if Assigned(FLoadPromiseOriginalAfterOpen) then
      FLoadPromiseOriginalAfterOpen(DataSet);
  end;
end;

function TMainData.CreateLoadPromise: TJSPromise;
begin
  Result := TJSPromise.new(procedure(resolve, reject: TJSPromiseResolver)
  begin
    FLoadPromiseResolve := resolve;
    if Assigned(FLoadPromiseDataset) then
      FLoadPromiseDataset.LoadAsync;
  end);
end;

procedure TMainData.CheckAllLoaded;
begin
  if FAllDataOpened.AllDone then
  begin
    ResetProcessingState;
    If Assigned(FOnReadyToProgress) then
      FOnReadyToProgress(True);
  end;
end;

procedure TMainData.CloseAllData;
begin

end;

Procedure TMainData.ConfigInit;
Var
  lParamValue: String;
  lLoginStarted: TDAteTime;

Begin
  Await(LoadConfig);

  If SessionValue[Process_State] <> '' Then
  Begin
    ProcessingState := TRttiEnumerationType.GetValue<TProcessingState>(SessionValue[Process_State]);
    SessionValue[Process_State] := '';
  End
  Else
    ProcessingState := TProcessingState.psStandard;

End;

procedure TMainData.CostingDetailDataSetAfterPost(DataSet: TDataSet);
begin
  TXDataWebDataSet(DataSet).ApplyUpdates;

end;

procedure TMainData.AutoReloadAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
begin
  TXDataDSUtils.UpdateAllRecords(TXDataWebDataSet(Sender), Info);

end;

Procedure TMainData.DataConnectionRequest(Args: TXDataWebConnectionRequest);
Begin
  If SphinxLogin.IsLoggedIn Then
    Args.Request.Headers.SetValue('Authorization', 'Bearer ' + SphinxLogin.AuthResult.AccessToken);
End;

Procedure TMainData.DataConnectionResponse(Args: TXDataWebConnectionResponse);
Begin
  // Check for 401 Unauthorized - session expired
  If Args.Response.StatusCode = 401 Then
  Begin
    // Logout and redirect to login screen
    LogoutUser(True);

  End;

End;

Function TMainData.GetDebugInfo: String;
Begin
{$IFNDEF RELEASE}
  Result := 'no debug info set';
{$ELSE}
  Result := '';
{$ENDIF}
End;

Function TMainData.GetLocalValue(Const Key: String): String;
Begin
  Result := TLocalStorage.GetValue(App_Name + '-' + Key);
End;

Function TMainData.GetPageSwitched: Boolean;
Begin
  Result := (FPreviousMainPage <> TMainAppPage.mpNone) And (FPreviousMainPage <> FMainPage);
End;

Function TMainData.GetSessionValue(Const Key: String): String;
Begin
  Result := TSessionStorage.GetValue(App_Name + '-' + Key);
End;

Procedure TMainData.HandleAnException(AException: EGeneralXDataException; Var Handled: Boolean);
Const
  support_svc = 'IsmxSupportService';
Begin

  // Await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(support_svc, [TJSJSON.Stringify(AException)]));
  Handled := True;
  If Assigned(FErrorMessageProc) Then
    FErrorMessageProc('We''re sorry, there''s been a problem with this. We are looking into it.'
{$IFDEF SHOWERROR} + ': ' + AException.Message{$ENDIF});

End;

Procedure TMainData.InitModule;
Var
  lLastSection: TMainAppPage;
  s: String;
Begin
  FormatSettings.DateSeparator := '/';
  FormatSettings.ShortDateFormat := 'dd/mm/yyyy';

{$IFDEF DEBUG}
  Application.ErrorType := aeFooter; // aeSilent, aeDialog, aeAlert, aeFooter
  Application.OnError := Nil;
  DataConnection.OnError := Nil;
  WebClient.OnError := Nil;
{$ELSE}
  Application.ErrorType := aeSilent; // aeSilent, aeDialog, aeAlert, aeFooter
  Application.OnError := OnApplicationError;
  // TODO -oAFP: where is this supposed to be defined?
//  DataConnection.OnError := DataConnectionError;
  DataConnection.OnError := nil;
  WebClient.OnError := WebClientError;
{$ENDIF}
  ProcessingState := TProcessingState.psStandard;

  try
    Await(DataConnection.OpenAsync);

  except
    SphinxLogin.Logout;

  end;

  Await(FetchUserProfile);

  TMainSiteForm.DisplayPage('content');

End;

Procedure TMainData.LoadConfig;
Var
  Conn: TXDataWebConnection;
  Response: IHttpResponse;
  Request: IHttpRequest;
  lBaseUrl: String;

Begin

  AppConfig.SphinxClientId := App_Web_App_Id;;

  // Get the base URL from the current page location
  lBaseUrl := String(TJSObject(window.location)['origin']);

  Conn := TXDataWebConnection.Create(Nil);
  Try
    Conn.URL := lBaseUrl;
    Response := await(IHttpResponse, Conn.SendRequestAsync(THttpRequest.Create('config/config.json')));
    If Response.StatusCode = 200 Then
    Begin
      AppConfig.Load(Response.ContentAsText);
      DataConnection.URL := AppConfig.BaseUrl;
      SphinxLogin.RedirectUri := AppConfig.CleanSphinxRedirectUri(Application.ExeName);
      SphinxLogin.ClientId := AppConfig.SphinxClientId;
      SphinxLogin.Scope := 'openid email';
      SphinxLogin.Authority := AppConfig.AuthURL;
    End;

  Finally
    Conn.Free;

  End;

End;

Function TMainData.LocalValueKeyStartsWith(Const Value: String): String;
Begin
  // for I := 0 to TWebLocalStorage.Count - 1 do

End;

Procedure TMainData.OnApplicationError(Sender: TObject; AError: TApplicationError; Var Handled: Boolean);
Begin
  HandleAnException(EGeneralXDataException.Create(AError), Handled);
End;

procedure TMainData.OpenAcademyLookUp;
begin
  AcademyLookUp.Close;
  AcademyLookUp.Active := False;
  AcademyLookUp.Load;

end;

procedure TMainData.OpenCostingLookUp;
begin
  CostingLookUp.Close;
  CostingLookUp.Active := False;
  CostingLookUp.Load;

end;

procedure TMainData.OpenSchoolLookUp;
begin
  SchoolLookUp.Close;
  SchoolLookUp.Active := False;
  
  // Reset promise state
  FLoadPromiseResolveCalled := False;
  FLoadPromiseDataset := SchoolLookUp;
  FLoadPromiseOriginalAfterOpen := SchoolLookUp.AfterOpen;
  
  // Set up AfterOpen handler before loading
  SchoolLookUp.AfterOpen := InternalAfterOpenForLoad;
  
  // Create and await a promise that resolves when the dataset is ready
  await(CreateLoadPromise);

end;

procedure TMainData.OpenCostingDetail(aCostingId: Integer);
begin
  CostingDetailDataSet.Close;
  CostingDetailDataSet.Active := False;
  CostingDetailDataSet.QueryString := '$filter= CostingId eq ' + IntToStr(aCostingId) + ' &$orderBy=PupilMin asc';
  CostingDetailDataSet.Filtered := True;
  CostingDetailDataSet.Load;

end;

procedure TMainData.OpenInvoiceDetail(aInvoiceId: Integer);
begin
  InvoiceDetailDataSet.Close;
  InvoiceDetailDataSet.Active := False;
  InvoiceDetailDataSet.QueryString := '$filter= InvoiceId eq ' + IntToStr(aInvoiceId);
  InvoiceDetailDataSet.Filtered := True;
  InvoiceDetailDataSet.Load;

end;

procedure TMainData.LoadInvoices(SchoolId: Integer);
begin
  InvoiceLookup.Close;
  InvoiceLookup.Active := False;
  InvoiceLookup.QueryString := '$filter= ParentId eq ' + IntToStr(SchoolId);
  InvoiceLookup.Filtered := True;
  
  // Reset promise state
  FLoadPromiseResolveCalled := False;
  FLoadPromiseDataset := InvoiceLookup;
  FLoadPromiseOriginalAfterOpen := InvoiceLookup.AfterOpen;
  
  // Set up AfterOpen handler before loading
  InvoiceLookup.AfterOpen := InternalAfterOpenForLoad;
  
  // Create and await a promise that resolves when the dataset is ready
  await(CreateLoadPromise);

end;

procedure TMainData.LoadRemittanceLookup(InvoiceId: Integer);
begin
  RemittanceLookup.Close;
  RemittanceLookup.Active := False;
  RemittanceLookup.QueryString := '$filter= InvoiceId eq ' + IntToStr(InvoiceId);
  RemittanceLookup.Filtered := True;
  RemittanceLookup.Load;

end;

procedure TMainData.LoadRemittanceById(Id: Integer);
begin
  RemittanceLookup.Close;
  RemittanceLookup.Active := False;
  RemittanceLookup.QueryString := '$filter= Id eq ' + IntToStr(Id);
  RemittanceLookup.Filtered := True;
  
  // Reset promise state
  FLoadPromiseResolveCalled := False;
  FLoadPromiseDataset := RemittanceLookup;
  FLoadPromiseOriginalAfterOpen := RemittanceLookup.AfterOpen;
  
  // Set up AfterOpen handler before loading
  RemittanceLookup.AfterOpen := InternalAfterOpenForLoad;
  
  // Create and await a promise that resolves when the dataset is ready
  await(CreateLoadPromise);

end;

procedure TMainData.LoadRemittances;
begin
  RemittanceLookup.Close;
  RemittanceLookup.Active := False;
  RemittanceLookup.QueryString := '';
  RemittanceLookup.Filtered := False;
  
  // Reset promise state
  FLoadPromiseResolveCalled := False;
  FLoadPromiseDataset := RemittanceLookup;
  FLoadPromiseOriginalAfterOpen := RemittanceLookup.AfterOpen;
  
  // Set up AfterOpen handler before loading
  RemittanceLookup.AfterOpen := InternalAfterOpenForLoad;
  
  // Create and await a promise that resolves when the dataset is ready
  await(CreateLoadPromise);

end;


Procedure TMainData.ProcessQuery;
Var
  lParamValue: String;
Begin

  // if HasQueryParam('bc', lParamValue, False) then
  // FSessionData.BrandCode := lParamValue;

End;

Procedure TMainData.RaiseException(Const AMessage: String);
Begin
  TheMainForm.HideWaitMessage;
  Raise Exception.Create(AMessage);
End;

Procedure TMainData.SaveAllData;
Begin

  FAllDataSaved.Clear;

  FStoredProcessingState := FProcessingState;
  ProcessingState := TProcessingState.psSavingData;

  // if (not CustomerIsInitiated) or (not TXDataDSUtils.PostAndApply(CustomerData)) then
  // begin
  // FAllDataSaved.Customer := True;
  // if not TXDataDSUtils.PostAndApply(BasketData) then
  // FAllDataSaved.Basket := True;
  // if not TXDataDSUtils.PostAndApply(PolicyData) then
  // begin
  // FAllDataSaved.Policy := True;
  // SaveAllDataCheck;
  // end;
  // end;
end;

Procedure TMainData.SaveAllDataCheck;
Var
  lState, lBookingState: String;
Begin
  If FAllDataSaved.AllDone Then
  Begin
    ResetProcessingState;

    lState := TRttiEnumerationType.GetName<TProcessingState>(ProcessingState);

    Case ProcessingState Of
      psStandard:
        Begin

        End;

      psSavingData:
        ;
    End;

    If Assigned(FOnReadyToProgress) Then
      FOnReadyToProgress(True);
  End;
End;

Procedure TMainData.SaveData;
Begin

  // Processingstate := TProcessingState.psSavingData;

  // If TXDataDSUtils.IsModified(CustomerData) Then
  // CustomerData.ApplyUpdates;

End;

Procedure TMainData.SetLocalValue(Const Key, Value: String);
Begin
  If Value = '' Then
    RemoveLocalValue(Key)
  Else
    TLocalStorage.SetValue(App_Name + '-' + Key, Value);
End;

procedure TMainData.RemoveLocalValue(const Key: string);
begin
  TLocalStorage.RemoveKey(App_Name + '-' + Key)

end;

Procedure TMainData.SetMainPage(Const Value: TMainAppPage);
Begin
  FMainPage := Value;
  SessionValue[Last_Section] := TRttiEnumerationType.GetName<TMainAppPage>(Value);
End;

Procedure TMainData.SetProcessingState(Const Value: TProcessingState);
Begin
  FProcessingState := Value;
End;

Procedure TMainData.SetSessionValue(Const Key, Value: String);
Begin
  if Value = '' then
    TSessionStorage.RemoveKey(App_Name + '-' + Key)
  else
    TSessionStorage.SetValue(App_Name + '-' + Key, Value);
End;

Procedure TMainData.SwitchMainPage(Const APage: TMainAppPage);
Begin

  If FMainPage = APage Then
    Exit;

  FPreviousMainPage := FMainPage;

End;

Procedure TMainData.UnlinkAllCallBacks;
Begin

  FOnReadyToProgress := Nil;

End;

Procedure TMainData.WebClientError(Error: TXDataClientError);
Var
  lHandled: Boolean;
  sErrorMessage: String;
Begin
  lHandled := False;
  
  // Check for 401 Unauthorized errors (session expired)
  sErrorMessage := LowerCase(Error.ErrorMessage);
  If (Error.StatusCode = 401) Or (Pos('unauthorized', sErrorMessage) > 0) Or (Pos('401', sErrorMessage) > 0) Then
  Begin
    // Session expired - logout and redirect to login
    LogoutUser(True);

  End;
  
  HandleAnException(EGeneralXDataException.Create(Error), lHandled);
End;

Procedure TMainData.WebDataModuleCreate(Sender: TObject);
Begin
  FPreviousMainPage := TMainAppPage.mpNone;
  FInitDone := False;
  FReloadOnInit := False;
  FUserProfile := TUserProfile.Create;

  Await(ConfigInit);

  try
    if not SphinxLogin.IsLoggedIn then
    begin
      ProcessQuery;
      SphinxLogin.Login;

    end
    else
      InitModule;

  except
    // Logout only if already logged in
    LogoutUser(False);

  end;

End;

procedure TMainData.WebDataModuleDestroy(Sender: TObject);
begin
  FUserProfile.Free;

end;

procedure TMainData.ResetProcessingState;
begin
  ProcessingState := FStoredProcessingState;
  FStoredProcessingState := TProcessingState.psStandard;
end;

procedure TMainData.FetchUserProfile;
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
begin
  lRetval := await(TXDataClientResponse, WebClient.RawInvokeAsync('IUserProfileService.GetCurrentUser', []));
  lResult := TJSObject(lRetval.Result);
  FUserProfile.UserName := string(lResult['UserName']);
  FUserProfile.Email := string(lResult['Email']);
  FUserProfile.Scope := string(lResult['Scope']);
end;

procedure TMainData.SphinxLoginUserLoggedIn(Args: TUserLoggedInArgs);
begin
  InitModule;
end;

procedure TMainData.DebugLog(aValue: string);
begin
  console.log(aValue);

end;

procedure TMainData.LogoutUser(Const AForceRelogin: Boolean = False);
begin
  // Clear app session/local state only (not whole browser storage)
  SetSessionValue(Process_State, '');
  SetSessionValue(Last_Section, '');
  RemoveLocalValue(Process_State);
  RemoveLocalValue(Last_Section);

  // Reset in-memory profile
  FUserProfile.UserName := '';
  FUserProfile.Email := '';
  FUserProfile.Scope := '';

  // End identity session
  if SphinxLogin.IsLoggedIn then
    SphinxLogin.Logout;

  // redirect back to login page
  if AForceRelogin then
    window.setTimeout(
      procedure
      begin
        SphinxLogin.Login;
      end, 100
    );

end;

procedure TMainData.LoadDFMValues;
begin
  inherited LoadDFMValues;

  DataConnection := TXDataWebConnection.Create(Self);
  WebClient := TXDataWebClient.Create(Self);
  DummyLookUp := TClientDataSet.Create(Self);
  DummyLookUpSource := TDataSource.Create(Self);
  SphinxLogin := TSphinxWebLogin.Create(Self);
  AcademyLookUp := TXDataWebDataSet.Create(Self);
  AcademyLookUpId := TIntegerField.Create(Self);
  AcademyLookUpName := TStringField.Create(Self);
  AcademyLookUpDateAdded := TDateTimeField.Create(Self);
  AcademyLookUpAddedBy := TIntegerField.Create(Self);
  AcademyLookUpLastUpdatedBy := TIntegerField.Create(Self);
  AcademyLookUpLastUpdated := TDateTimeField.Create(Self);
  AcademyLookUpEmail := TStringField.Create(Self);
  AcademyLookUpTelephone := TStringField.Create(Self);
  SchoolLookUp := TXDataWebDataSet.Create(Self);
  IntegerField1 := TIntegerField.Create(Self);
  SchoolLookUpLocationName := TStringField.Create(Self);
  SchoolLookUpDateAdded := TDateTimeField.Create(Self);
  SchoolLookUpAddedBy := TIntegerField.Create(Self);
  SchoolLookUpLastUpdatedBy := TIntegerField.Create(Self);
  SchoolLookUpLastUpdated := TDateTimeField.Create(Self);
  SchoolLookUpAdd1 := TStringField.Create(Self);
  SchoolLookUpAdd2 := TStringField.Create(Self);
  SchoolLookUpAdd3 := TStringField.Create(Self);
  SchoolLookUpTown := TStringField.Create(Self);
  SchoolLookUpRegion := TStringField.Create(Self);
  SchoolLookUpPostCode := TStringField.Create(Self);
  SchoolLookUpCountryCode := TStringField.Create(Self);
  SchoolLookUpExternalId := TStringField.Create(Self);
  SchoolLookUpTelephone := TStringField.Create(Self);
  SchoolLookUpEmail := TStringField.Create(Self);
  SchoolLookUpLocalAuthority := TStringField.Create(Self);
  SchoolLookUpAcademyId := TIntegerField.Create(Self);
  SchoolLookUpStatus := TStringField.Create(Self);
  SchoolLookUpSchoolKind := TStringField.Create(Self);
  SchoolLookUpPupilCount := TIntegerField.Create(Self);
  SchoolLookUpCostingId := TIntegerField.Create(Self);
  CostingDetailDataSet := TXDataWebDataSet.Create(Self);
  CostingDetailDataSetId := TIntegerField.Create(Self);
  CostingDetailDataSetDateAdded := TDateTimeField.Create(Self);
  CostingDetailDataSetAddedBy := TIntegerField.Create(Self);
  CostingDetailDataSetLastUpdatedBy := TIntegerField.Create(Self);
  CostingDetailDataSetLastUpdated := TDateTimeField.Create(Self);
  CostingDetailDataSetCostingId := TIntegerField.Create(Self);
  CostingDetailDataSetPupilMin := TIntegerField.Create(Self);
  CostingDetailDataSetPupilMax := TIntegerField.Create(Self);
  CostingDetailDataSetCostValue := TFloatField.Create(Self);
  WebClientDataSet1 := TClientDataSet.Create(Self);
  WebClientConnector1 := TClientConnector.Create(Self);
  InvoiceDetailDataSet := TXDataWebDataSet.Create(Self);
  InvoiceDetailDataSetId := TIntegerField.Create(Self);
  InvoiceDetailDataSetDateAdded := TDateTimeField.Create(Self);
  InvoiceDetailDataSetAddedBy := TIntegerField.Create(Self);
  InvoiceDetailDataSetLastUpdatedBy := TIntegerField.Create(Self);
  InvoiceDetailDataSetLastUpdated := TDateTimeField.Create(Self);
  InvoiceDetailDataSetDescription := TStringField.Create(Self);
  InvoiceDetailDataSetInvoiceId := TIntegerField.Create(Self);
  InvoiceDetailDataSetQuantity := TIntegerField.Create(Self);
  InvoiceDetailDataSetRate := TFloatField.Create(Self);
  InvoiceDetailDataSetTotalValue := TFloatField.Create(Self);
  InvoiceLookup := TXDataWebDataSet.Create(Self);
  InvoiceLookupId := TIntegerField.Create(Self);
  InvoiceLookupDateAdded := TDateTimeField.Create(Self);
  InvoiceLookupAddedBy := TIntegerField.Create(Self);
  InvoiceLookupLastUpdatedBy := TIntegerField.Create(Self);
  InvoiceLookupLastUpdated := TDateTimeField.Create(Self);
  InvoiceLookupDueDate := TDateField.Create(Self);
  InvoiceLookupGrossAmount := TFloatField.Create(Self);
  InvoiceLookupInvoiceDate := TDateField.Create(Self);
  InvoiceLookupInvoiceRef := TStringField.Create(Self);
  InvoiceLookupInvoiceType := TStringField.Create(Self);
  InvoiceLookupNetAmount := TFloatField.Create(Self);
  InvoiceLookupParentId := TIntegerField.Create(Self);
  InvoiceLookupTaxRate := TFloatField.Create(Self);
  InvoiceLookupTax := TFloatField.Create(Self);
  InvoiceLookupTotalAmount := TFloatField.Create(Self);
  InvoiceLookupPaidInFull := TBooleanField.Create(Self);
  InvoiceLookupHandbookSent := TBooleanField.Create(Self);
  RemittanceLookup := TXDataWebDataSet.Create(Self);
  RemittanceLookupId := TIntegerField.Create(Self);
  RemittanceLookupDateAdded := TDateTimeField.Create(Self);
  RemittanceLookupAddedBy := TIntegerField.Create(Self);
  RemittanceLookupLastUpdatedBy := TIntegerField.Create(Self);
  RemittanceLookupLastUpdated := TDateTimeField.Create(Self);
  RemittanceLookupInvoiceId := TIntegerField.Create(Self);
  RemittanceLookupSchoolId := TIntegerField.Create(Self);
  RemittanceLookupPaymentMethod := TStringField.Create(Self);
  RemittanceLookupRemittanceDate := TDateField.Create(Self);
  RemittanceLookupPaymentState := TStringField.Create(Self);
  RemittanceLookupAmount := TFloatField.Create(Self);
  RemittanceLookupPaymentRef := TStringField.Create(Self);
  RemittanceLookupPaymentKind := TStringField.Create(Self);
  CostingLookUp := TXDataWebDataSet.Create(Self);
  CostingLookUpId := TIntegerField.Create(Self);
  CostingLookUpDateAdded := TDateTimeField.Create(Self);
  CostingLookUpAddedBy := TIntegerField.Create(Self);
  CostingLookUpLastUpdatedBy := TIntegerField.Create(Self);
  CostingLookUpLastUpdated := TDateTimeField.Create(Self);
  CostingLookUpTitle := TStringField.Create(Self);
  CostingLookUpValidFrom := TDateTimeField.Create(Self);
  CostingLookUpValidTo := TDateTimeField.Create(Self);

  DataConnection.BeforeLoadDFMValues;
  WebClient.BeforeLoadDFMValues;
  DummyLookUp.BeforeLoadDFMValues;
  DummyLookUpSource.BeforeLoadDFMValues;
  SphinxLogin.BeforeLoadDFMValues;
  AcademyLookUp.BeforeLoadDFMValues;
  AcademyLookUpId.BeforeLoadDFMValues;
  AcademyLookUpName.BeforeLoadDFMValues;
  AcademyLookUpDateAdded.BeforeLoadDFMValues;
  AcademyLookUpAddedBy.BeforeLoadDFMValues;
  AcademyLookUpLastUpdatedBy.BeforeLoadDFMValues;
  AcademyLookUpLastUpdated.BeforeLoadDFMValues;
  AcademyLookUpEmail.BeforeLoadDFMValues;
  AcademyLookUpTelephone.BeforeLoadDFMValues;
  SchoolLookUp.BeforeLoadDFMValues;
  IntegerField1.BeforeLoadDFMValues;
  SchoolLookUpLocationName.BeforeLoadDFMValues;
  SchoolLookUpDateAdded.BeforeLoadDFMValues;
  SchoolLookUpAddedBy.BeforeLoadDFMValues;
  SchoolLookUpLastUpdatedBy.BeforeLoadDFMValues;
  SchoolLookUpLastUpdated.BeforeLoadDFMValues;
  SchoolLookUpAdd1.BeforeLoadDFMValues;
  SchoolLookUpAdd2.BeforeLoadDFMValues;
  SchoolLookUpAdd3.BeforeLoadDFMValues;
  SchoolLookUpTown.BeforeLoadDFMValues;
  SchoolLookUpRegion.BeforeLoadDFMValues;
  SchoolLookUpPostCode.BeforeLoadDFMValues;
  SchoolLookUpCountryCode.BeforeLoadDFMValues;
  SchoolLookUpExternalId.BeforeLoadDFMValues;
  SchoolLookUpTelephone.BeforeLoadDFMValues;
  SchoolLookUpEmail.BeforeLoadDFMValues;
  SchoolLookUpLocalAuthority.BeforeLoadDFMValues;
  SchoolLookUpAcademyId.BeforeLoadDFMValues;
  SchoolLookUpStatus.BeforeLoadDFMValues;
  SchoolLookUpSchoolKind.BeforeLoadDFMValues;
  SchoolLookUpPupilCount.BeforeLoadDFMValues;
  SchoolLookUpCostingId.BeforeLoadDFMValues;
  CostingDetailDataSet.BeforeLoadDFMValues;
  CostingDetailDataSetId.BeforeLoadDFMValues;
  CostingDetailDataSetDateAdded.BeforeLoadDFMValues;
  CostingDetailDataSetAddedBy.BeforeLoadDFMValues;
  CostingDetailDataSetLastUpdatedBy.BeforeLoadDFMValues;
  CostingDetailDataSetLastUpdated.BeforeLoadDFMValues;
  CostingDetailDataSetCostingId.BeforeLoadDFMValues;
  CostingDetailDataSetPupilMin.BeforeLoadDFMValues;
  CostingDetailDataSetPupilMax.BeforeLoadDFMValues;
  CostingDetailDataSetCostValue.BeforeLoadDFMValues;
  WebClientDataSet1.BeforeLoadDFMValues;
  WebClientConnector1.BeforeLoadDFMValues;
  InvoiceDetailDataSet.BeforeLoadDFMValues;
  InvoiceDetailDataSetId.BeforeLoadDFMValues;
  InvoiceDetailDataSetDateAdded.BeforeLoadDFMValues;
  InvoiceDetailDataSetAddedBy.BeforeLoadDFMValues;
  InvoiceDetailDataSetLastUpdatedBy.BeforeLoadDFMValues;
  InvoiceDetailDataSetLastUpdated.BeforeLoadDFMValues;
  InvoiceDetailDataSetDescription.BeforeLoadDFMValues;
  InvoiceDetailDataSetInvoiceId.BeforeLoadDFMValues;
  InvoiceDetailDataSetQuantity.BeforeLoadDFMValues;
  InvoiceDetailDataSetRate.BeforeLoadDFMValues;
  InvoiceDetailDataSetTotalValue.BeforeLoadDFMValues;
  InvoiceLookup.BeforeLoadDFMValues;
  InvoiceLookupId.BeforeLoadDFMValues;
  InvoiceLookupDateAdded.BeforeLoadDFMValues;
  InvoiceLookupAddedBy.BeforeLoadDFMValues;
  InvoiceLookupLastUpdatedBy.BeforeLoadDFMValues;
  InvoiceLookupLastUpdated.BeforeLoadDFMValues;
  InvoiceLookupDueDate.BeforeLoadDFMValues;
  InvoiceLookupGrossAmount.BeforeLoadDFMValues;
  InvoiceLookupInvoiceDate.BeforeLoadDFMValues;
  InvoiceLookupInvoiceRef.BeforeLoadDFMValues;
  InvoiceLookupInvoiceType.BeforeLoadDFMValues;
  InvoiceLookupNetAmount.BeforeLoadDFMValues;
  InvoiceLookupParentId.BeforeLoadDFMValues;
  InvoiceLookupTaxRate.BeforeLoadDFMValues;
  InvoiceLookupTax.BeforeLoadDFMValues;
  InvoiceLookupTotalAmount.BeforeLoadDFMValues;
  InvoiceLookupPaidInFull.BeforeLoadDFMValues;
  InvoiceLookupHandbookSent.BeforeLoadDFMValues;
  RemittanceLookup.BeforeLoadDFMValues;
  RemittanceLookupId.BeforeLoadDFMValues;
  RemittanceLookupDateAdded.BeforeLoadDFMValues;
  RemittanceLookupAddedBy.BeforeLoadDFMValues;
  RemittanceLookupLastUpdatedBy.BeforeLoadDFMValues;
  RemittanceLookupLastUpdated.BeforeLoadDFMValues;
  RemittanceLookupInvoiceId.BeforeLoadDFMValues;
  RemittanceLookupSchoolId.BeforeLoadDFMValues;
  RemittanceLookupPaymentMethod.BeforeLoadDFMValues;
  RemittanceLookupRemittanceDate.BeforeLoadDFMValues;
  RemittanceLookupPaymentState.BeforeLoadDFMValues;
  RemittanceLookupAmount.BeforeLoadDFMValues;
  RemittanceLookupPaymentRef.BeforeLoadDFMValues;
  RemittanceLookupPaymentKind.BeforeLoadDFMValues;
  CostingLookUp.BeforeLoadDFMValues;
  CostingLookUpId.BeforeLoadDFMValues;
  CostingLookUpDateAdded.BeforeLoadDFMValues;
  CostingLookUpAddedBy.BeforeLoadDFMValues;
  CostingLookUpLastUpdatedBy.BeforeLoadDFMValues;
  CostingLookUpLastUpdated.BeforeLoadDFMValues;
  CostingLookUpTitle.BeforeLoadDFMValues;
  CostingLookUpValidFrom.BeforeLoadDFMValues;
  CostingLookUpValidTo.BeforeLoadDFMValues;
  try
    Name := 'MainData';
    SetEvent(Self, 'OnCreate', 'WebDataModuleCreate');
    SetEvent(Self, 'OnDestroy', 'WebDataModuleDestroy');
    Height := 497;
    Width := 792;
    DataConnection.SetParentComponent(Self);
    DataConnection.Name := 'DataConnection';
    DataConnection.URL := 'localhost:2026:/catscserver';
    SetEvent(DataConnection, Self, 'OnRequest', 'DataConnectionRequest');
    SetEvent(DataConnection, Self, 'OnResponse', 'DataConnectionResponse');
    DataConnection.Left := 64;
    DataConnection.Top := 32;
    WebClient.SetParentComponent(Self);
    WebClient.Name := 'WebClient';
    WebClient.Connection := DataConnection;
    SetEvent(WebClient, Self, 'OnError', 'WebClientError');
    WebClient.Left := 64;
    WebClient.Top := 104;
    DummyLookUp.SetParentComponent(Self);
    DummyLookUp.Name := 'DummyLookUp';
    DummyLookUp.Left := 256;
    DummyLookUp.Top := 32;
    DummyLookUpSource.SetParentComponent(Self);
    DummyLookUpSource.Name := 'DummyLookUpSource';
    DummyLookUpSource.DataSet := DummyLookUp;
    DummyLookUpSource.Left := 392;
    DummyLookUpSource.Top := 32;
    SphinxLogin.SetParentComponent(Self);
    SphinxLogin.Name := 'SphinxLogin';
    SetEvent(SphinxLogin, Self, 'OnUserLoggedIn', 'SphinxLoginUserLoggedIn');
    SphinxLogin.Left := 64;
    SphinxLogin.Top := 176;
    AcademyLookUp.SetParentComponent(Self);
    AcademyLookUp.Name := 'AcademyLookUp';
    AcademyLookUp.EntitySetName := 'Academy';
    AcademyLookUp.Connection := DataConnection;
    AcademyLookUp.Left := 608;
    AcademyLookUp.Top := 224;
    AcademyLookUpId.SetParentComponent(AcademyLookUp);
    AcademyLookUpId.Name := 'AcademyLookUpId';
    AcademyLookUpId.FieldName := 'Id';
    AcademyLookUpId.Required := True;
    AcademyLookUpName.SetParentComponent(AcademyLookUp);
    AcademyLookUpName.Name := 'AcademyLookUpName';
    AcademyLookUpName.FieldName := 'Name';
    AcademyLookUpName.Size := 255;
    AcademyLookUpDateAdded.SetParentComponent(AcademyLookUp);
    AcademyLookUpDateAdded.Name := 'AcademyLookUpDateAdded';
    AcademyLookUpDateAdded.FieldName := 'DateAdded';
    AcademyLookUpDateAdded.Required := True;
    AcademyLookUpAddedBy.SetParentComponent(AcademyLookUp);
    AcademyLookUpAddedBy.Name := 'AcademyLookUpAddedBy';
    AcademyLookUpAddedBy.FieldName := 'AddedBy';
    AcademyLookUpAddedBy.Required := True;
    AcademyLookUpLastUpdatedBy.SetParentComponent(AcademyLookUp);
    AcademyLookUpLastUpdatedBy.Name := 'AcademyLookUpLastUpdatedBy';
    AcademyLookUpLastUpdatedBy.FieldName := 'LastUpdatedBy';
    AcademyLookUpLastUpdated.SetParentComponent(AcademyLookUp);
    AcademyLookUpLastUpdated.Name := 'AcademyLookUpLastUpdated';
    AcademyLookUpLastUpdated.FieldName := 'LastUpdated';
    AcademyLookUpEmail.SetParentComponent(AcademyLookUp);
    AcademyLookUpEmail.Name := 'AcademyLookUpEmail';
    AcademyLookUpEmail.FieldName := 'Email';
    AcademyLookUpEmail.Size := 320;
    AcademyLookUpTelephone.SetParentComponent(AcademyLookUp);
    AcademyLookUpTelephone.Name := 'AcademyLookUpTelephone';
    AcademyLookUpTelephone.FieldName := 'Telephone';
    AcademyLookUpTelephone.Size := 25;
    SchoolLookUp.SetParentComponent(Self);
    SchoolLookUp.Name := 'SchoolLookUp';
    SchoolLookUp.EntitySetName := 'School';
    SchoolLookUp.Connection := DataConnection;
    SchoolLookUp.Left := 608;
    SchoolLookUp.Top := 288;
    IntegerField1.SetParentComponent(SchoolLookUp);
    IntegerField1.Name := 'IntegerField1';
    IntegerField1.FieldName := 'Id';
    IntegerField1.Required := True;
    SchoolLookUpLocationName.SetParentComponent(SchoolLookUp);
    SchoolLookUpLocationName.Name := 'SchoolLookUpLocationName';
    SchoolLookUpLocationName.FieldName := 'LocationName';
    SchoolLookUpLocationName.Size := 255;
    SchoolLookUpDateAdded.SetParentComponent(SchoolLookUp);
    SchoolLookUpDateAdded.Name := 'SchoolLookUpDateAdded';
    SchoolLookUpDateAdded.FieldName := 'DateAdded';
    SchoolLookUpDateAdded.Required := True;
    SchoolLookUpAddedBy.SetParentComponent(SchoolLookUp);
    SchoolLookUpAddedBy.Name := 'SchoolLookUpAddedBy';
    SchoolLookUpAddedBy.FieldName := 'AddedBy';
    SchoolLookUpAddedBy.Required := True;
    SchoolLookUpLastUpdatedBy.SetParentComponent(SchoolLookUp);
    SchoolLookUpLastUpdatedBy.Name := 'SchoolLookUpLastUpdatedBy';
    SchoolLookUpLastUpdatedBy.FieldName := 'LastUpdatedBy';
    SchoolLookUpLastUpdated.SetParentComponent(SchoolLookUp);
    SchoolLookUpLastUpdated.Name := 'SchoolLookUpLastUpdated';
    SchoolLookUpLastUpdated.FieldName := 'LastUpdated';
    SchoolLookUpAdd1.SetParentComponent(SchoolLookUp);
    SchoolLookUpAdd1.Name := 'SchoolLookUpAdd1';
    SchoolLookUpAdd1.FieldName := 'Add1';
    SchoolLookUpAdd1.Size := 100;
    SchoolLookUpAdd2.SetParentComponent(SchoolLookUp);
    SchoolLookUpAdd2.Name := 'SchoolLookUpAdd2';
    SchoolLookUpAdd2.FieldName := 'Add2';
    SchoolLookUpAdd2.Size := 100;
    SchoolLookUpAdd3.SetParentComponent(SchoolLookUp);
    SchoolLookUpAdd3.Name := 'SchoolLookUpAdd3';
    SchoolLookUpAdd3.FieldName := 'Add3';
    SchoolLookUpAdd3.Size := 100;
    SchoolLookUpTown.SetParentComponent(SchoolLookUp);
    SchoolLookUpTown.Name := 'SchoolLookUpTown';
    SchoolLookUpTown.FieldName := 'Town';
    SchoolLookUpTown.Size := 75;
    SchoolLookUpRegion.SetParentComponent(SchoolLookUp);
    SchoolLookUpRegion.Name := 'SchoolLookUpRegion';
    SchoolLookUpRegion.FieldName := 'Region';
    SchoolLookUpRegion.Size := 75;
    SchoolLookUpPostCode.SetParentComponent(SchoolLookUp);
    SchoolLookUpPostCode.Name := 'SchoolLookUpPostCode';
    SchoolLookUpPostCode.FieldName := 'PostCode';
    SchoolLookUpPostCode.Size := 25;
    SchoolLookUpCountryCode.SetParentComponent(SchoolLookUp);
    SchoolLookUpCountryCode.Name := 'SchoolLookUpCountryCode';
    SchoolLookUpCountryCode.FieldName := 'CountryCode';
    SchoolLookUpCountryCode.Size := 2;
    SchoolLookUpExternalId.SetParentComponent(SchoolLookUp);
    SchoolLookUpExternalId.Name := 'SchoolLookUpExternalId';
    SchoolLookUpExternalId.FieldName := 'ExternalId';
    SchoolLookUpExternalId.Size := 75;
    SchoolLookUpTelephone.SetParentComponent(SchoolLookUp);
    SchoolLookUpTelephone.Name := 'SchoolLookUpTelephone';
    SchoolLookUpTelephone.FieldName := 'Telephone';
    SchoolLookUpTelephone.Size := 25;
    SchoolLookUpEmail.SetParentComponent(SchoolLookUp);
    SchoolLookUpEmail.Name := 'SchoolLookUpEmail';
    SchoolLookUpEmail.FieldName := 'Email';
    SchoolLookUpEmail.Size := 320;
    SchoolLookUpLocalAuthority.SetParentComponent(SchoolLookUp);
    SchoolLookUpLocalAuthority.Name := 'SchoolLookUpLocalAuthority';
    SchoolLookUpLocalAuthority.FieldName := 'LocalAuthority';
    SchoolLookUpLocalAuthority.Size := 50;
    SchoolLookUpAcademyId.SetParentComponent(SchoolLookUp);
    SchoolLookUpAcademyId.Name := 'SchoolLookUpAcademyId';
    SchoolLookUpAcademyId.FieldName := 'AcademyId';
    SchoolLookUpStatus.SetParentComponent(SchoolLookUp);
    SchoolLookUpStatus.Name := 'SchoolLookUpStatus';
    SchoolLookUpStatus.FieldName := 'Status';
    SchoolLookUpStatus.Required := True;
    SchoolLookUpStatus.Size := 8;
    SchoolLookUpSchoolKind.SetParentComponent(SchoolLookUp);
    SchoolLookUpSchoolKind.Name := 'SchoolLookUpSchoolKind';
    SchoolLookUpSchoolKind.FieldName := 'SchoolKind';
    SchoolLookUpSchoolKind.Required := True;
    SchoolLookUpSchoolKind.Size := 11;
    SchoolLookUpPupilCount.SetParentComponent(SchoolLookUp);
    SchoolLookUpPupilCount.Name := 'SchoolLookUpPupilCount';
    SchoolLookUpPupilCount.FieldName := 'PupilCount';
    SchoolLookUpCostingId.SetParentComponent(SchoolLookUp);
    SchoolLookUpCostingId.Name := 'SchoolLookUpCostingId';
    SchoolLookUpCostingId.FieldName := 'CostingId';
    CostingDetailDataSet.SetParentComponent(Self);
    CostingDetailDataSet.Name := 'CostingDetailDataSet';
    CostingDetailDataSet.AfterApplyUpdates := AutoReloadAfterApplyUpdates;
    CostingDetailDataSet.AfterPost := CostingDetailDataSetAfterPost;
    CostingDetailDataSet.EntitySetName := 'CostingDetail';
    CostingDetailDataSet.Connection := DataConnection;
    CostingDetailDataSet.Left := 256;
    CostingDetailDataSet.Top := 256;
    CostingDetailDataSetId.SetParentComponent(CostingDetailDataSet);
    CostingDetailDataSetId.Name := 'CostingDetailDataSetId';
    CostingDetailDataSetId.FieldName := 'Id';
    CostingDetailDataSetDateAdded.SetParentComponent(CostingDetailDataSet);
    CostingDetailDataSetDateAdded.Name := 'CostingDetailDataSetDateAdded';
    CostingDetailDataSetDateAdded.FieldName := 'DateAdded';
    CostingDetailDataSetAddedBy.SetParentComponent(CostingDetailDataSet);
    CostingDetailDataSetAddedBy.Name := 'CostingDetailDataSetAddedBy';
    CostingDetailDataSetAddedBy.FieldName := 'AddedBy';
    CostingDetailDataSetLastUpdatedBy.SetParentComponent(CostingDetailDataSet);
    CostingDetailDataSetLastUpdatedBy.Name := 'CostingDetailDataSetLastUpdatedBy';
    CostingDetailDataSetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    CostingDetailDataSetLastUpdated.SetParentComponent(CostingDetailDataSet);
    CostingDetailDataSetLastUpdated.Name := 'CostingDetailDataSetLastUpdated';
    CostingDetailDataSetLastUpdated.FieldName := 'LastUpdated';
    CostingDetailDataSetCostingId.SetParentComponent(CostingDetailDataSet);
    CostingDetailDataSetCostingId.Name := 'CostingDetailDataSetCostingId';
    CostingDetailDataSetCostingId.FieldName := 'CostingId';
    CostingDetailDataSetPupilMin.SetParentComponent(CostingDetailDataSet);
    CostingDetailDataSetPupilMin.Name := 'CostingDetailDataSetPupilMin';
    CostingDetailDataSetPupilMin.FieldName := 'PupilMin';
    CostingDetailDataSetPupilMax.SetParentComponent(CostingDetailDataSet);
    CostingDetailDataSetPupilMax.Name := 'CostingDetailDataSetPupilMax';
    CostingDetailDataSetPupilMax.FieldName := 'PupilMax';
    CostingDetailDataSetCostValue.SetParentComponent(CostingDetailDataSet);
    CostingDetailDataSetCostValue.Name := 'CostingDetailDataSetCostValue';
    CostingDetailDataSetCostValue.FieldName := 'CostValue';
    WebClientDataSet1.SetParentComponent(Self);
    WebClientDataSet1.Name := 'WebClientDataSet1';
    WebClientDataSet1.Left := 160;
    WebClientDataSet1.Top := 392;
    WebClientConnector1.SetParentComponent(Self);
    WebClientConnector1.Name := 'WebClientConnector1';
    WebClientConnector1.Left := 312;
    WebClientConnector1.Top := 392;
    InvoiceDetailDataSet.SetParentComponent(Self);
    InvoiceDetailDataSet.Name := 'InvoiceDetailDataSet';
    InvoiceDetailDataSet.AfterApplyUpdates := AutoReloadAfterApplyUpdates;
    InvoiceDetailDataSet.EntitySetName := 'SchoolInvoiceDetail';
    InvoiceDetailDataSet.Connection := DataConnection;
    InvoiceDetailDataSet.Left := 392;
    InvoiceDetailDataSet.Top := 256;
    InvoiceDetailDataSetId.SetParentComponent(InvoiceDetailDataSet);
    InvoiceDetailDataSetId.Name := 'InvoiceDetailDataSetId';
    InvoiceDetailDataSetId.FieldName := 'Id';
    InvoiceDetailDataSetDateAdded.SetParentComponent(InvoiceDetailDataSet);
    InvoiceDetailDataSetDateAdded.Name := 'InvoiceDetailDataSetDateAdded';
    InvoiceDetailDataSetDateAdded.FieldName := 'DateAdded';
    InvoiceDetailDataSetAddedBy.SetParentComponent(InvoiceDetailDataSet);
    InvoiceDetailDataSetAddedBy.Name := 'InvoiceDetailDataSetAddedBy';
    InvoiceDetailDataSetAddedBy.FieldName := 'AddedBy';
    InvoiceDetailDataSetLastUpdatedBy.SetParentComponent(InvoiceDetailDataSet);
    InvoiceDetailDataSetLastUpdatedBy.Name := 'InvoiceDetailDataSetLastUpdatedBy';
    InvoiceDetailDataSetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    InvoiceDetailDataSetLastUpdated.SetParentComponent(InvoiceDetailDataSet);
    InvoiceDetailDataSetLastUpdated.Name := 'InvoiceDetailDataSetLastUpdated';
    InvoiceDetailDataSetLastUpdated.FieldName := 'LastUpdated';
    InvoiceDetailDataSetDescription.SetParentComponent(InvoiceDetailDataSet);
    InvoiceDetailDataSetDescription.Name := 'InvoiceDetailDataSetDescription';
    InvoiceDetailDataSetDescription.FieldName := 'Description';
    InvoiceDetailDataSetDescription.Size := 100;
    InvoiceDetailDataSetInvoiceId.SetParentComponent(InvoiceDetailDataSet);
    InvoiceDetailDataSetInvoiceId.Name := 'InvoiceDetailDataSetInvoiceId';
    InvoiceDetailDataSetInvoiceId.FieldName := 'InvoiceId';
    InvoiceDetailDataSetQuantity.SetParentComponent(InvoiceDetailDataSet);
    InvoiceDetailDataSetQuantity.Name := 'InvoiceDetailDataSetQuantity';
    InvoiceDetailDataSetQuantity.FieldName := 'Quantity';
    InvoiceDetailDataSetRate.SetParentComponent(InvoiceDetailDataSet);
    InvoiceDetailDataSetRate.Name := 'InvoiceDetailDataSetRate';
    InvoiceDetailDataSetRate.FieldName := 'Rate';
    InvoiceDetailDataSetTotalValue.SetParentComponent(InvoiceDetailDataSet);
    InvoiceDetailDataSetTotalValue.Name := 'InvoiceDetailDataSetTotalValue';
    InvoiceDetailDataSetTotalValue.FieldName := 'TotalValue';
    InvoiceLookup.SetParentComponent(Self);
    InvoiceLookup.Name := 'InvoiceLookup';
    InvoiceLookup.EntitySetName := 'SchoolInvoice';
    InvoiceLookup.Connection := DataConnection;
    InvoiceLookup.Left := 608;
    InvoiceLookup.Top := 32;
    InvoiceLookupId.SetParentComponent(InvoiceLookup);
    InvoiceLookupId.Name := 'InvoiceLookupId';
    InvoiceLookupId.FieldName := 'Id';
    InvoiceLookupId.Required := True;
    InvoiceLookupDateAdded.SetParentComponent(InvoiceLookup);
    InvoiceLookupDateAdded.Name := 'InvoiceLookupDateAdded';
    InvoiceLookupDateAdded.FieldName := 'DateAdded';
    InvoiceLookupDateAdded.Required := True;
    InvoiceLookupAddedBy.SetParentComponent(InvoiceLookup);
    InvoiceLookupAddedBy.Name := 'InvoiceLookupAddedBy';
    InvoiceLookupAddedBy.FieldName := 'AddedBy';
    InvoiceLookupAddedBy.Required := True;
    InvoiceLookupLastUpdatedBy.SetParentComponent(InvoiceLookup);
    InvoiceLookupLastUpdatedBy.Name := 'InvoiceLookupLastUpdatedBy';
    InvoiceLookupLastUpdatedBy.FieldName := 'LastUpdatedBy';
    InvoiceLookupLastUpdated.SetParentComponent(InvoiceLookup);
    InvoiceLookupLastUpdated.Name := 'InvoiceLookupLastUpdated';
    InvoiceLookupLastUpdated.FieldName := 'LastUpdated';
    InvoiceLookupDueDate.SetParentComponent(InvoiceLookup);
    InvoiceLookupDueDate.Name := 'InvoiceLookupDueDate';
    InvoiceLookupDueDate.FieldName := 'DueDate';
    InvoiceLookupDueDate.Required := True;
    InvoiceLookupGrossAmount.SetParentComponent(InvoiceLookup);
    InvoiceLookupGrossAmount.Name := 'InvoiceLookupGrossAmount';
    InvoiceLookupGrossAmount.FieldName := 'GrossAmount';
    InvoiceLookupGrossAmount.Required := True;
    InvoiceLookupInvoiceDate.SetParentComponent(InvoiceLookup);
    InvoiceLookupInvoiceDate.Name := 'InvoiceLookupInvoiceDate';
    InvoiceLookupInvoiceDate.FieldName := 'InvoiceDate';
    InvoiceLookupInvoiceDate.Required := True;
    InvoiceLookupInvoiceRef.SetParentComponent(InvoiceLookup);
    InvoiceLookupInvoiceRef.Name := 'InvoiceLookupInvoiceRef';
    InvoiceLookupInvoiceRef.FieldName := 'InvoiceRef';
    InvoiceLookupInvoiceRef.Size := 50;
    InvoiceLookupInvoiceType.SetParentComponent(InvoiceLookup);
    InvoiceLookupInvoiceType.Name := 'InvoiceLookupInvoiceType';
    InvoiceLookupInvoiceType.FieldName := 'InvoiceType';
    InvoiceLookupInvoiceType.Required := True;
    InvoiceLookupInvoiceType.Size := 10;
    InvoiceLookupNetAmount.SetParentComponent(InvoiceLookup);
    InvoiceLookupNetAmount.Name := 'InvoiceLookupNetAmount';
    InvoiceLookupNetAmount.FieldName := 'NetAmount';
    InvoiceLookupNetAmount.Required := True;
    InvoiceLookupParentId.SetParentComponent(InvoiceLookup);
    InvoiceLookupParentId.Name := 'InvoiceLookupParentId';
    InvoiceLookupParentId.FieldName := 'ParentId';
    InvoiceLookupParentId.Required := True;
    InvoiceLookupTaxRate.SetParentComponent(InvoiceLookup);
    InvoiceLookupTaxRate.Name := 'InvoiceLookupTaxRate';
    InvoiceLookupTaxRate.FieldName := 'TaxRate';
    InvoiceLookupTaxRate.Required := True;
    InvoiceLookupTax.SetParentComponent(InvoiceLookup);
    InvoiceLookupTax.Name := 'InvoiceLookupTax';
    InvoiceLookupTax.FieldName := 'Tax';
    InvoiceLookupTax.Required := True;
    InvoiceLookupTotalAmount.SetParentComponent(InvoiceLookup);
    InvoiceLookupTotalAmount.Name := 'InvoiceLookupTotalAmount';
    InvoiceLookupTotalAmount.FieldName := 'TotalAmount';
    InvoiceLookupTotalAmount.Required := True;
    InvoiceLookupPaidInFull.SetParentComponent(InvoiceLookup);
    InvoiceLookupPaidInFull.Name := 'InvoiceLookupPaidInFull';
    InvoiceLookupPaidInFull.FieldName := 'PaidInFull';
    InvoiceLookupHandbookSent.SetParentComponent(InvoiceLookup);
    InvoiceLookupHandbookSent.Name := 'InvoiceLookupHandbookSent';
    InvoiceLookupHandbookSent.FieldName := 'HandbookSent';
    RemittanceLookup.SetParentComponent(Self);
    RemittanceLookup.Name := 'RemittanceLookup';
    RemittanceLookup.EntitySetName := 'Payment';
    RemittanceLookup.Connection := DataConnection;
    RemittanceLookup.Left := 608;
    RemittanceLookup.Top := 96;
    RemittanceLookupId.SetParentComponent(RemittanceLookup);
    RemittanceLookupId.Name := 'RemittanceLookupId';
    RemittanceLookupId.FieldName := 'Id';
    RemittanceLookupId.Required := True;
    RemittanceLookupDateAdded.SetParentComponent(RemittanceLookup);
    RemittanceLookupDateAdded.Name := 'RemittanceLookupDateAdded';
    RemittanceLookupDateAdded.FieldName := 'DateAdded';
    RemittanceLookupDateAdded.Required := True;
    RemittanceLookupAddedBy.SetParentComponent(RemittanceLookup);
    RemittanceLookupAddedBy.Name := 'RemittanceLookupAddedBy';
    RemittanceLookupAddedBy.FieldName := 'AddedBy';
    RemittanceLookupAddedBy.Required := True;
    RemittanceLookupLastUpdatedBy.SetParentComponent(RemittanceLookup);
    RemittanceLookupLastUpdatedBy.Name := 'RemittanceLookupLastUpdatedBy';
    RemittanceLookupLastUpdatedBy.FieldName := 'LastUpdatedBy';
    RemittanceLookupLastUpdated.SetParentComponent(RemittanceLookup);
    RemittanceLookupLastUpdated.Name := 'RemittanceLookupLastUpdated';
    RemittanceLookupLastUpdated.FieldName := 'LastUpdated';
    RemittanceLookupInvoiceId.SetParentComponent(RemittanceLookup);
    RemittanceLookupInvoiceId.Name := 'RemittanceLookupInvoiceId';
    RemittanceLookupInvoiceId.FieldName := 'InvoiceId';
    RemittanceLookupInvoiceId.Required := True;
    RemittanceLookupSchoolId.SetParentComponent(RemittanceLookup);
    RemittanceLookupSchoolId.Name := 'RemittanceLookupSchoolId';
    RemittanceLookupSchoolId.FieldName := 'SchoolId';
    RemittanceLookupSchoolId.Required := True;
    RemittanceLookupPaymentMethod.SetParentComponent(RemittanceLookup);
    RemittanceLookupPaymentMethod.Name := 'RemittanceLookupPaymentMethod';
    RemittanceLookupPaymentMethod.FieldName := 'PaymentMethod';
    RemittanceLookupPaymentMethod.Required := True;
    RemittanceLookupPaymentMethod.Size := 6;
    RemittanceLookupRemittanceDate.SetParentComponent(RemittanceLookup);
    RemittanceLookupRemittanceDate.Name := 'RemittanceLookupRemittanceDate';
    RemittanceLookupRemittanceDate.FieldName := 'RemittanceDate';
    RemittanceLookupRemittanceDate.Required := True;
    RemittanceLookupPaymentState.SetParentComponent(RemittanceLookup);
    RemittanceLookupPaymentState.Name := 'RemittanceLookupPaymentState';
    RemittanceLookupPaymentState.FieldName := 'PaymentState';
    RemittanceLookupPaymentState.Required := True;
    RemittanceLookupPaymentState.Size := 9;
    RemittanceLookupAmount.SetParentComponent(RemittanceLookup);
    RemittanceLookupAmount.Name := 'RemittanceLookupAmount';
    RemittanceLookupAmount.FieldName := 'Amount';
    RemittanceLookupAmount.Required := True;
    RemittanceLookupPaymentRef.SetParentComponent(RemittanceLookup);
    RemittanceLookupPaymentRef.Name := 'RemittanceLookupPaymentRef';
    RemittanceLookupPaymentRef.FieldName := 'PaymentRef';
    RemittanceLookupPaymentRef.Size := 50;
    RemittanceLookupPaymentKind.SetParentComponent(RemittanceLookup);
    RemittanceLookupPaymentKind.Name := 'RemittanceLookupPaymentKind';
    RemittanceLookupPaymentKind.FieldName := 'PaymentKind';
    RemittanceLookupPaymentKind.Required := True;
    RemittanceLookupPaymentKind.Size := 7;
    CostingLookUp.SetParentComponent(Self);
    CostingLookUp.Name := 'CostingLookUp';
    CostingLookUp.EntitySetName := 'Costing';
    CostingLookUp.Connection := DataConnection;
    CostingLookUp.Left := 608;
    CostingLookUp.Top := 160;
    CostingLookUpId.SetParentComponent(CostingLookUp);
    CostingLookUpId.Name := 'CostingLookUpId';
    CostingLookUpId.FieldName := 'Id';
    CostingLookUpId.Required := True;
    CostingLookUpDateAdded.SetParentComponent(CostingLookUp);
    CostingLookUpDateAdded.Name := 'CostingLookUpDateAdded';
    CostingLookUpDateAdded.FieldName := 'DateAdded';
    CostingLookUpDateAdded.Required := True;
    CostingLookUpAddedBy.SetParentComponent(CostingLookUp);
    CostingLookUpAddedBy.Name := 'CostingLookUpAddedBy';
    CostingLookUpAddedBy.FieldName := 'AddedBy';
    CostingLookUpAddedBy.Required := True;
    CostingLookUpLastUpdatedBy.SetParentComponent(CostingLookUp);
    CostingLookUpLastUpdatedBy.Name := 'CostingLookUpLastUpdatedBy';
    CostingLookUpLastUpdatedBy.FieldName := 'LastUpdatedBy';
    CostingLookUpLastUpdated.SetParentComponent(CostingLookUp);
    CostingLookUpLastUpdated.Name := 'CostingLookUpLastUpdated';
    CostingLookUpLastUpdated.FieldName := 'LastUpdated';
    CostingLookUpTitle.SetParentComponent(CostingLookUp);
    CostingLookUpTitle.Name := 'CostingLookUpTitle';
    CostingLookUpTitle.FieldName := 'Title';
    CostingLookUpTitle.Size := 50;
    CostingLookUpValidFrom.SetParentComponent(CostingLookUp);
    CostingLookUpValidFrom.Name := 'CostingLookUpValidFrom';
    CostingLookUpValidFrom.FieldName := 'ValidFrom';
    CostingLookUpValidFrom.Required := True;
    CostingLookUpValidTo.SetParentComponent(CostingLookUp);
    CostingLookUpValidTo.Name := 'CostingLookUpValidTo';
    CostingLookUpValidTo.FieldName := 'ValidTo';
    CostingLookUpValidTo.Required := True;
  finally
    DataConnection.AfterLoadDFMValues;
    WebClient.AfterLoadDFMValues;
    DummyLookUp.AfterLoadDFMValues;
    DummyLookUpSource.AfterLoadDFMValues;
    SphinxLogin.AfterLoadDFMValues;
    AcademyLookUp.AfterLoadDFMValues;
    AcademyLookUpId.AfterLoadDFMValues;
    AcademyLookUpName.AfterLoadDFMValues;
    AcademyLookUpDateAdded.AfterLoadDFMValues;
    AcademyLookUpAddedBy.AfterLoadDFMValues;
    AcademyLookUpLastUpdatedBy.AfterLoadDFMValues;
    AcademyLookUpLastUpdated.AfterLoadDFMValues;
    AcademyLookUpEmail.AfterLoadDFMValues;
    AcademyLookUpTelephone.AfterLoadDFMValues;
    SchoolLookUp.AfterLoadDFMValues;
    IntegerField1.AfterLoadDFMValues;
    SchoolLookUpLocationName.AfterLoadDFMValues;
    SchoolLookUpDateAdded.AfterLoadDFMValues;
    SchoolLookUpAddedBy.AfterLoadDFMValues;
    SchoolLookUpLastUpdatedBy.AfterLoadDFMValues;
    SchoolLookUpLastUpdated.AfterLoadDFMValues;
    SchoolLookUpAdd1.AfterLoadDFMValues;
    SchoolLookUpAdd2.AfterLoadDFMValues;
    SchoolLookUpAdd3.AfterLoadDFMValues;
    SchoolLookUpTown.AfterLoadDFMValues;
    SchoolLookUpRegion.AfterLoadDFMValues;
    SchoolLookUpPostCode.AfterLoadDFMValues;
    SchoolLookUpCountryCode.AfterLoadDFMValues;
    SchoolLookUpExternalId.AfterLoadDFMValues;
    SchoolLookUpTelephone.AfterLoadDFMValues;
    SchoolLookUpEmail.AfterLoadDFMValues;
    SchoolLookUpLocalAuthority.AfterLoadDFMValues;
    SchoolLookUpAcademyId.AfterLoadDFMValues;
    SchoolLookUpStatus.AfterLoadDFMValues;
    SchoolLookUpSchoolKind.AfterLoadDFMValues;
    SchoolLookUpPupilCount.AfterLoadDFMValues;
    SchoolLookUpCostingId.AfterLoadDFMValues;
    CostingDetailDataSet.AfterLoadDFMValues;
    CostingDetailDataSetId.AfterLoadDFMValues;
    CostingDetailDataSetDateAdded.AfterLoadDFMValues;
    CostingDetailDataSetAddedBy.AfterLoadDFMValues;
    CostingDetailDataSetLastUpdatedBy.AfterLoadDFMValues;
    CostingDetailDataSetLastUpdated.AfterLoadDFMValues;
    CostingDetailDataSetCostingId.AfterLoadDFMValues;
    CostingDetailDataSetPupilMin.AfterLoadDFMValues;
    CostingDetailDataSetPupilMax.AfterLoadDFMValues;
    CostingDetailDataSetCostValue.AfterLoadDFMValues;
    WebClientDataSet1.AfterLoadDFMValues;
    WebClientConnector1.AfterLoadDFMValues;
    InvoiceDetailDataSet.AfterLoadDFMValues;
    InvoiceDetailDataSetId.AfterLoadDFMValues;
    InvoiceDetailDataSetDateAdded.AfterLoadDFMValues;
    InvoiceDetailDataSetAddedBy.AfterLoadDFMValues;
    InvoiceDetailDataSetLastUpdatedBy.AfterLoadDFMValues;
    InvoiceDetailDataSetLastUpdated.AfterLoadDFMValues;
    InvoiceDetailDataSetDescription.AfterLoadDFMValues;
    InvoiceDetailDataSetInvoiceId.AfterLoadDFMValues;
    InvoiceDetailDataSetQuantity.AfterLoadDFMValues;
    InvoiceDetailDataSetRate.AfterLoadDFMValues;
    InvoiceDetailDataSetTotalValue.AfterLoadDFMValues;
    InvoiceLookup.AfterLoadDFMValues;
    InvoiceLookupId.AfterLoadDFMValues;
    InvoiceLookupDateAdded.AfterLoadDFMValues;
    InvoiceLookupAddedBy.AfterLoadDFMValues;
    InvoiceLookupLastUpdatedBy.AfterLoadDFMValues;
    InvoiceLookupLastUpdated.AfterLoadDFMValues;
    InvoiceLookupDueDate.AfterLoadDFMValues;
    InvoiceLookupGrossAmount.AfterLoadDFMValues;
    InvoiceLookupInvoiceDate.AfterLoadDFMValues;
    InvoiceLookupInvoiceRef.AfterLoadDFMValues;
    InvoiceLookupInvoiceType.AfterLoadDFMValues;
    InvoiceLookupNetAmount.AfterLoadDFMValues;
    InvoiceLookupParentId.AfterLoadDFMValues;
    InvoiceLookupTaxRate.AfterLoadDFMValues;
    InvoiceLookupTax.AfterLoadDFMValues;
    InvoiceLookupTotalAmount.AfterLoadDFMValues;
    InvoiceLookupPaidInFull.AfterLoadDFMValues;
    InvoiceLookupHandbookSent.AfterLoadDFMValues;
    RemittanceLookup.AfterLoadDFMValues;
    RemittanceLookupId.AfterLoadDFMValues;
    RemittanceLookupDateAdded.AfterLoadDFMValues;
    RemittanceLookupAddedBy.AfterLoadDFMValues;
    RemittanceLookupLastUpdatedBy.AfterLoadDFMValues;
    RemittanceLookupLastUpdated.AfterLoadDFMValues;
    RemittanceLookupInvoiceId.AfterLoadDFMValues;
    RemittanceLookupSchoolId.AfterLoadDFMValues;
    RemittanceLookupPaymentMethod.AfterLoadDFMValues;
    RemittanceLookupRemittanceDate.AfterLoadDFMValues;
    RemittanceLookupPaymentState.AfterLoadDFMValues;
    RemittanceLookupAmount.AfterLoadDFMValues;
    RemittanceLookupPaymentRef.AfterLoadDFMValues;
    RemittanceLookupPaymentKind.AfterLoadDFMValues;
    CostingLookUp.AfterLoadDFMValues;
    CostingLookUpId.AfterLoadDFMValues;
    CostingLookUpDateAdded.AfterLoadDFMValues;
    CostingLookUpAddedBy.AfterLoadDFMValues;
    CostingLookUpLastUpdatedBy.AfterLoadDFMValues;
    CostingLookUpLastUpdated.AfterLoadDFMValues;
    CostingLookUpTitle.AfterLoadDFMValues;
    CostingLookUpValidFrom.AfterLoadDFMValues;
    CostingLookUpValidTo.AfterLoadDFMValues;
  end;
end;

end.
